import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';

import {SueloCore} from '../../../../../chacra-core';

export {SueloCore} from '../../../../../chacra-core';


export const suelosAdapter: EntityAdapter<SueloCore> = createEntityAdapter<SueloCore>({
  selectId: model => model.sueloId,
  sortComparer: (a: SueloCore, b: SueloCore): number =>
    b.sueloId.localeCompare(a.sueloId)
});

export interface SuelosState extends EntityState<SueloCore> {
  isLoading?: boolean;
  error?: string | null;
}

export const initialState: SuelosState = suelosAdapter.getInitialState(
  {
    isLoading: false,
    error: null
  }
);
